"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("./index.style");

var _Section$propTypes;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var Section = function Section(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      _ref$angle = _ref.angle,
      angle = _ref$angle === void 0 ? '' : _ref$angle,
      noTop = _ref.noTop,
      noBottom = _ref.noBottom,
      noLeft = _ref.noLeft,
      noRight = _ref.noRight,
      _ref$variantX = _ref.variantX,
      variantX = _ref$variantX === void 0 ? 'default' : _ref$variantX,
      _ref$variantY = _ref.variantY,
      variantY = _ref$variantY === void 0 ? 'default' : _ref$variantY,
      scrollX = _ref.scrollX,
      scrollY = _ref.scrollY,
      _ref$footer_cta = _ref.footer_cta,
      footer_cta = _ref$footer_cta === void 0 ? '' : _ref$footer_cta,
      _ref$footer_url = _ref.footer_url,
      footer_url = _ref$footer_url === void 0 ? '' : _ref$footer_url,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '' : _ref$background,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? '' : _ref$heading,
      description = _ref.description,
      _ref$footer_heading = _ref.footer_heading,
      footer_heading = _ref$footer_heading === void 0 ? '' : _ref$footer_heading,
      _ref$pendoTag = _ref.pendoTag,
      pendoTag = _ref$pendoTag === void 0 ? '' : _ref$pendoTag; // 2.1. FUNCTIONS ............................................................
  // 2.2.1. RENDER HEADER

  var renderHeader = function renderHeader(HEADING, DESC) {
    if (HEADING || DESC) {
      return _react["default"].createElement(_index.SectionHeader, null, HEADING && _react["default"].createElement("h2", {
        "data-pendo": pendoTag
      }, HEADING), DESC);
    }

    return null;
  }; // 2.2.1. END
  // 2.2.2. RENDER FOOTER


  var renderFooter = function renderFooter(HEADING, CTA, URL) {
    if (HEADING || footer_url) {
      return _react["default"].createElement(_index.SectionFooter, null, HEADING && _react["default"].createElement("h3", null, HEADING), CTA && _react["default"].createElement("a", {
        href: URL
      }, CTA));
    }

    return null;
  }; // 2.2.2. END
  // 2.1. END ..................................................................
  // 2.2. RENDER COMPONENT .....................................................


  return _react["default"].createElement(_index.SectionContainer, {
    style: style,
    angle: angle,
    noTop: noTop,
    noBottom: noBottom,
    noLeft: noLeft,
    noRight: noRight,
    variantX: variantX,
    variantY: variantY,
    scrollX: scrollX,
    scrollY: scrollY,
    className: className,
    background: background
  }, renderHeader(heading, description), children, renderFooter(footer_heading, footer_cta, footer_url)); // 2.2. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


Section.propTypes = (_Section$propTypes = {
  style: _propTypes["default"].object,
  noTop: _propTypes["default"].bool,
  pendoTag: _propTypes["default"].string,
  noBottom: _propTypes["default"].bool,
  noLeft: _propTypes["default"].bool,
  noRight: _propTypes["default"].bool,
  variantX: _propTypes["default"].oneOf(['default', 'wide', 'narrow']).isRequired,
  variantY: _propTypes["default"].oneOf(['default', 'shallow', 'deep']).isRequired,
  scrollX: _propTypes["default"].bool,
  scrollY: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  heading: _propTypes["default"].string,
  className: _propTypes["default"].string
}, _defineProperty(_Section$propTypes, "className", _propTypes["default"].string), _defineProperty(_Section$propTypes, "footer_cta", _propTypes["default"].string), _defineProperty(_Section$propTypes, "footer_url", _propTypes["default"].string), _defineProperty(_Section$propTypes, "description", _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])), _defineProperty(_Section$propTypes, "footer_heading", _propTypes["default"].string), _Section$propTypes); // 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = Section; // END OF FILE #################################################################

exports["default"] = _default;